enum DiscountType {
  Percentage = 'percentage',
  Amount = 'amount',
}

/**
 * Calculates the price after applying a discount.
 *
 * @param {number} basePrice - original price before any discount.
 * @param {DiscountType} discountType -type of discount ('percentage' or 'amount').
 * @param {number} discountAmount - value of the discount, either a percentage or a fixed amount.
 * @returns {number} - final price after applying the discount. If calculated price is less than zero, returns zero.
 */
export const calculatePriceAfterDiscount = (
  basePrice: number,
  discountType: DiscountType,
  discountValue: number,
): number => {
  let discountedPrice = basePrice;

  if (discountType === DiscountType.Percentage) {
    discountedPrice -= (discountValue / 100) * basePrice;
  } else if (discountType === DiscountType.Amount) {
    discountedPrice -= discountValue;
  }

  return discountedPrice >= 0 ? discountedPrice : 0;
};
